export default "__VITE_ASSET__b73ddc14__"